import React from "react";

import * as Styled from "./styles";
import { useMenuItems } from "./hooks";

const Navigation: React.FC = () => {
  const items = useMenuItems();

  return <Styled.Navigation mode="inline" {...{ items }} />;
};

export default Navigation;
